// extracted by mini-css-extract-plugin
module.exports = {"title":"title-section-module--title--6FGUm","title_hash":"title-section-module--title_hash--1GcQZ"};